import React from 'react';

const Service = () => {
  return (
    <div className="flex flex-col bg-[#fcd38d] py-10 px-4 sm:px-10 lg:px-16 justify-center items-center space-y-10">
      <h1 className="text-3xl sm:text-4xl font-bold text-[#4C3A2B] text-center">
        Our Services
      </h1>
      <div className="flex flex-wrap justify-center gap-6">
        <div className="flex flex-col p-4 justify-center items-center w-full max-w-[260px] h-[14rem] bg-[#f3af38]/25 rounded-lg shadow-sm shadow-[#4C3A2B] text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-[#4C3A2B]">
            Temple Pooja Services
          </h1>
          <p className="text-sm sm:text-base font-medium text-[#4C3A2B]">
            Experience spiritual upliftment through our daily and special poojas performed with devotion and tradition.
          </p>
        </div>

        <div className="flex flex-col p-4 justify-center items-center w-full max-w-[260px] h-[14rem] bg-[#f3af38]/25 rounded-lg shadow-sm shadow-[#4C3A2B] text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-[#4C3A2B]">
            Spiritual Counseling
          </h1>
          <p className="text-sm sm:text-base font-medium text-[#4C3A2B]">
            One-on-one guidance sessions to help you navigate life’s challenges with wisdom and faith.
          </p>
        </div>

        <div className="flex flex-col p-4 justify-center items-center w-full max-w-[260px] h-[14rem] bg-[#f3af38]/25 rounded-lg shadow-sm shadow-[#4C3A2B] text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-[#4C3A2B]">
            Vedic Learning Programs
          </h1>
          <p className="text-sm sm:text-base font-medium text-[#4C3A2B]">
            Join our classes on Sanskrit, Vedic chanting, and spiritual philosophy for all age groups.
          </p>
        </div>

        <div className="flex flex-col p-4 justify-center items-center w-full max-w-[260px] h-[14rem] bg-[#f3af38]/25 rounded-lg shadow-sm shadow-[#4C3A2B] text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-[#4C3A2B]">
            Annadanam
          </h1>
          <p className="text-sm sm:text-base font-medium text-[#4C3A2B]">
            Partake in or sponsor free meals offered to devotees and the underprivileged every day.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-6">
        <div className="flex flex-col p-4 justify-center items-center w-full max-w-[260px] h-[14rem] bg-[#f3af38]/25 rounded-lg shadow-sm shadow-[#4C3A2B] text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-[#4C3A2B]">
            Temple Pooja Services
          </h1>
          <p className="text-sm sm:text-base font-medium text-[#4C3A2B]">
            Experience spiritual upliftment through our daily and special poojas performed with devotion and tradition.
          </p>
        </div>

        <div className="flex flex-col p-4 justify-center items-center w-full max-w-[260px] h-[14rem] bg-[#f3af38]/25 rounded-lg shadow-sm shadow-[#4C3A2B] text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-[#4C3A2B]">
            Spiritual Counseling
          </h1>
          <p className="text-sm sm:text-base font-medium text-[#4C3A2B]">
            One-on-one guidance sessions to help you navigate life’s challenges with wisdom and faith.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Service;
